module.exports = __webpack_public_path__ + "static/media/criteria-not-found-d.e1068c64.svg";